import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  content: {
    color: '#fff',
  },
  cardsList: {
    width: '100%',
    maxWidth: 380,
    margin: '0 auto',
  },
  messageOrderDontExist: {
    color: '#fff',
    fontWeight: 700,
    textAlign: 'center',
    fontSize: theme.fonts.sizes.font18PX,
  },
  errorPart: {
    width: '100%',
    maxWidth: 380,
    minHeight: '100vh',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.colors.light.freshPowder,
  },
  errorMessage: {
    fontSize: theme.fonts.sizes.font16PX,
    fontWeight: 700,
  },
}));
